module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_8004.f14bc12e.png";